import React from 'react';
import { cn } from '../../../../utils/cn';

type TabBarProps<T extends string> = {
  tabs: { key: T; label: string; count?: number }[];
  active: T;
  onChange: (key: T) => void;
};

export const TabBar = <T extends string>({ tabs, active, onChange }: TabBarProps<T>) => (
  <div
    className="flex gap-1 overflow-x-auto overflow-y-hidden border-b border-gray-200 px-2 md:px-3"
    role="tablist"
  >
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={active === tab.key}
        onClick={() => onChange(tab.key)}
        className={cn(
          '-mb-px flex h-11 shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap border-b-2 px-2.5 text-[14px] font-gilroy-medium transition-colors',
          active === tab.key
            ? 'border-neutral-500 text-neutral-500'
            : 'border-transparent text-neutral-300 hover:text-neutral-500'
        )}
      >
        {tab.label}
        {typeof tab.count === 'number' && (
          <span
            className={cn(
              'rounded-full px-1.5 text-[12px] tabular-nums',
              active === tab.key ? 'bg-neutral-500 text-white' : 'bg-creams-300 text-neutral-400'
            )}
          >
            {tab.count}
          </span>
        )}
      </button>
    ))}
  </div>
);
